import React, { FC } from 'react';
import { css } from 'emotion';
import { Text } from '@weave/design-system';
import { weaveTheme } from '@weave/theme-original/dist/weaveTheme';

export const LocationAlert: FC<{ color: 'success' | 'danger' | 'warning' }> = (props) => {
  const backgroundColor =
    props.color === 'success'
      ? weaveTheme.colors.success
      : props.color === 'warning'
      ? weaveTheme.colors.warning
      : weaveTheme.colors.error;

  return (
    <Text
      color="white"
      className={css`
        background-color: ${backgroundColor};
        padding: 4px 8px;
        border-radius: 12px;
      `}
    >
      <>{props.children}</>
    </Text>
  );
};
